import React from 'react'
import Icon from '@ant-design/icons'

const LifestyleGoalSvgIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_297_45109)">
      <path
        d="M29 1.99951H6V0.999512C6 0.447266 5.55273 -0.000488281 5 -0.000488281C4.44727 -0.000488281 4 0.447266 4 0.999512V30.9995C4 31.5518 4.44727 31.9995 5 31.9995C5.55273 31.9995 6 31.5518 6 30.9995V19.9995H29C29.5527 19.9995 30 19.5518 30 18.9995V2.99951C30 2.44727 29.5527 1.99951 29 1.99951ZM28 9.99951H22V3.99951H28V9.99951ZM20 11.9995V17.9995H14V11.9995H20ZM12 3.99951V9.99951H6V3.99951H12Z"
        fill="#264382"
      />
    </g>
    <defs>
      <clipPath id="clip0_297_45109">
        <rect
          width="32"
          height="32"
          fill="white"
          transform="translate(0 -0.000488281)"
        />
      </clipPath>
    </defs>
  </svg>
)

export const LifestyleGoalIcon = (props) => (
  <Icon component={LifestyleGoalSvgIcon} {...props} />
)
